import * as React from 'react';

export function withRenderOnFirstTabOnly<P>(){
   return ( WrappedComponent: any
    ): React.ComponentClass<P> => {

    return class extends React.Component<P> {
      public constructor(props: P) {
        super(props);
      }

      private get firstSectionSelected() {
        const {
          firstSection,
          expandAll,
          activeSection
        } = this.props as any;
        if (!expandAll && activeSection && firstSection) {
          return activeSection === firstSection;
        }
        return expandAll;
      }

      public render() {
        return this.firstSectionSelected ? <WrappedComponent {...this.props}/> : null;
      }
    };
  };
}
